import {useDispatch, useSelector} from "react-redux";
import React, {useEffect, useState} from "react";
import {
    setInsertNewPrimerPosListData,
    setPrimerPosListRequestData,
    setPrimerPosListResponseData,
    setSelectedPrimerPosList
} from "../../../../_reducers/DataPanel/Clients/clientSlice";
import ReportsTemplate from "../../../common/ReportsTemplate";
import {Badge, Button, Col, Row} from "react-bootstrap";
import DateBox from "../../../primer/DateBox";
import moment from "moment";
import Input from "../../../common/Input";
import Dropdown from "../../../primer/Dropdown";
import DateHelper from "../../../primer/DateHelper/DateHelper";
import axios from "axios";
import {toast} from "react-toastify";
import InsertPosListModal from "./primer-pos-modals/insert-pos-list-modal";
import PrimerPosListModal from "./primer-pos-modals/primer-pos-list-modal";
import AcsEmailModal from "./primer-pos-modals/AcsEmailModal";
import {useTranslation} from "../../../../hooks/useTranslation";

const PrimerPosViewList = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const requestData = useSelector((state) => state.CLIENTS_DATA.primerPosListRequestData);
    const responseData = useSelector((state) => state.CLIENTS_DATA.primerPosListResponseData);
    const selectedPosList = useSelector((state) => state.CLIENTS_DATA.selectedPrimerPosList);
    const insertListData = useSelector((state) => state.CLIENTS_DATA.insertNewPrimerPosListData);

    const [pageChanged, setPageChanged] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showAcsEmailModal, setShowAcsEmailModal] = useState(false);

    const statusOptions = [
        {value: "pending", label: "Εκκρεμής", color: "#fff5bd"},
        {value: "completed", label: "Ολοκληρωμένη", color: "#b1fcb1"},
        {value: "cancelled", label: "Ακυρωμένη", color: "#ffcfcf"},
    ];

    useEffect(() => {
        if (pageChanged) {
            setPageChanged(false);
            fetchReport(true);
        }
    }, [pageChanged])

    useEffect(() => {
        if(!selectedPosList && responseData?.data?.length > 0){
            fetchReport(true);
        }
    }, [selectedPosList]);


    const handleOnChange = (e, type, name) => {
        if (type === "datebox") {
            if (moment(e).isValid()) {
                dispatch(setPrimerPosListRequestData({...requestData, [name] : moment(e).format("DD/MM/YYYY")}));
            } else {
                dispatch(setPrimerPosListRequestData({...requestData, [name] : ""}));
            }
        } else if (type === "checkbox") {
            dispatch(setPrimerPosListRequestData({...requestData, [name] : e.target.checked}));
        } else if (type === "dropdown") {
            if (name === "status") {
                dispatch(setPrimerPosListRequestData({...requestData, status: e}));
            } else {
                dispatch(setPrimerPosListRequestData({...requestData, [name] : e.value}));
            }
        } else if(type === "input") {
            dispatch(setPrimerPosListRequestData({...requestData, [name] : e.target.value}));
        }
    }

    const toFirstPage = () => {
        dispatch(setPrimerPosListRequestData({...requestData, page: 1}));
        setPageChanged(true);
    }
    const toPreviousPage = () => {
        dispatch(setPrimerPosListRequestData({...requestData, page: requestData.page - 1}));
        setPageChanged(true);
    }
    const toNextPage = () => {
        dispatch(setPrimerPosListRequestData({...requestData, page: requestData.page + 1}));
        setPageChanged(true);
    }
    const toLastPage = () => {
        dispatch(setPrimerPosListRequestData({...requestData, page: responseData.totalPages}));
        setPageChanged(true);
    }

    const fetchReport = (fromPagination = false) => {
        setLoading(true);
        let reqData = {...requestData, company: company.id}
        if (!fromPagination) {
            reqData.page = 1;
            dispatch(setPrimerPosListRequestData({...requestData, page: 1}));
        }
        axios.post(`${process.env.REACT_APP_API_URL2}/client/primer-pos-list`, reqData, {
            headers: { 'Content-Type': 'application/json' },
        }).then((res) => {
            setLoading(false);
            if (res.data.status === "200") {
                if (res.data?.data?.data?.length === 0) {
                    toast.info("Δεν βρέθηκαν δεδομένα.");
                } else {
                    if (!fromPagination) {
                        toast.success("Τα δεδομένα ανανεώθηκαν", {autoClose: 1000});
                    }
                }
                let cloneData = structuredClone(res.data.data?.data || []);
                cloneData.forEach((obj, i) => {
                    obj.no = 20 * Number(res.data.data.currentPage - 1) + i + 1;
                })
                dispatch(setPrimerPosListResponseData({...responseData, data: cloneData, totalPages: res.data?.data?.totalPages}));
            } else {
                dispatch(setPrimerPosListResponseData({data: [], totalPages: 0}));
                toast.error(res.data.message);
            }
        }).catch((err) => {
            dispatch(setPrimerPosListResponseData({data: [], totalPages: 0}));
            setLoading(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    return (
        <React.Fragment>
            <ReportsTemplate templateType={"primer-pos-search-list"} requestData={requestData} fetchReport={() => fetchReport()} setRequestData={(data) => dispatch(setPrimerPosListRequestData(data))} header={"Λίστες Αποστολής ACS"} />
            <Row onKeyDown={(e) => {
                if (e.key === "Enter") fetchReport(false)}
            }>
                <Row className={"mb-1"}>
                    <Col md={2}>
                    <DateHelper dateFromAndToFunction={(from, to) => dispatch(setPrimerPosListRequestData({...requestData, date_from: from, date_to: to}))} />
                    </Col>
                    <Col md={2}>
                        <DateBox
                            label={"Ημ/νία από"}
                            allowOtherYears={true}
                            selected={moment(requestData.date_from, "DD/MM/YYYY").isValid() ? moment(requestData.date_from, "DD/MM/YYYY").toDate() : null}
                            onChange={(e) => handleOnChange(e, "datebox", "date_from")}
                        />
                    </Col>
                    <Col md={2}>
                        <DateBox
                            label={"Ημ/νία έως"}
                            allowOtherYears={true}
                            selected={moment(requestData.date_to, "DD/MM/YYYY").isValid() ? moment(requestData.date_to, "DD/MM/YYYY").toDate() : null}
                            onChange={(e) => handleOnChange(e, "datebox", "date_to")}
                        />
                    </Col>
                    <Col md={3}>
                        <Dropdown
                            name={"status"}
                            label={"Κατάσταση Λίστας"}
                            options={statusOptions}
                            multiSelect={true}
                            defaultValue={requestData?.status}
                            onChange={(e) => handleOnChange(e, "dropdown", "status")}
                        />
                    </Col>
                </Row>
                <Row className={"mb-2"}>
                    <Col md={3}>
                        <Input
                            name="listId"
                            label="Αναγνωριστικό Λίστας"
                            autoComplete="off"
                            value={requestData.listId}
                            onChange={(e) => handleOnChange(e, "input", "listId")}
                        />
                    </Col>
                    <Col md={3}>
                        <Input
                            name="acsVoucher"
                            label="ACS Voucher"
                            autoComplete="off"
                            value={requestData.acsVoucher}
                            onChange={(e) => handleOnChange(e, "input", "acsVoucher")}
                        />
                    </Col>
                    <Col md={3}>
                        <Input
                            name="client"
                            label="Όνομα/ΑΦΜ Πελάτη"
                            autoComplete="off"
                            value={requestData.client}
                            onChange={(e) => handleOnChange(e, "input", "client")}
                        />
                    </Col>
                    <Col md={3}>
                        <Input
                            name="serialNumber"
                            label="Σειριακός Αριθμός Συσκευής"
                            autoComplete="off"
                            value={requestData.serialNumber}
                            onChange={(e) => handleOnChange(e, "input", "serialNumber")}
                        />
                    </Col>
                </Row>
            </Row>
            <Row>
                <Col md={12}>
                    <Button onClick={() => fetchReport()} className="btn btn-primary float-right" disabled={loading}>
                        {t('General.applyFilter')}
                        {loading && (<span className="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span>)}
                    </Button>
                    <Button onClick={() => setShowAcsEmailModal(true)} className="btn btn-primary float-right mr-3" disabled={loading}>
                        Αποστολή Email στην ACS για παραλαβή
                        {loading && (<span className="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span>)}
                    </Button>
                    <Button onClick={() => dispatch(setInsertNewPrimerPosListData({...insertListData, show: true}))} className="btn btn-primary float-right mr-3" disabled={loading}>
                        Δημιουργία Λίστας
                    </Button>
                </Col>
            </Row>
            {responseData.totalPages > 0 && (
                <React.Fragment>
                    <hr/>
                    <Col md={12}>
                        <div className="d-flex justify-content-end mb-2">
                            <Button
                                size={"sm"}
                                className={"mr-1"}
                                onClick={() => toFirstPage()}
                                disabled={requestData.page === 1 || loading}>
                                {t('SalesBalanceSheet.first')}
                            </Button>
                            <Button
                                size={"sm"}
                                className={"mr-1"}
                                onClick={() => toPreviousPage()}
                                disabled={requestData.page === 1 || loading}>
                                {t('SalesBalanceSheet.previous')}
                            </Button>
                            <Badge style={{fontSize: "12px", lineHeight: "20px"}} className="mr-1"
                                   bg="primary">{t('SalesBalanceSheet.page')} {requestData.page} / {responseData.totalPages}</Badge>
                            <Button
                                size={"sm"}
                                className={"mr-1"}
                                onClick={() => toNextPage()}
                                disabled={requestData.page === responseData.totalPages || loading}>
                                {t('SalesBalanceSheet.next')}
                            </Button>
                            <Button
                                size={"sm"}
                                className={"mr-1"}
                                onClick={() => toLastPage()}
                                disabled={requestData.page === responseData.totalPages || loading}>
                                {t('SalesBalanceSheet.last')}
                            </Button>
                        </div>
                    </Col>
                </React.Fragment>
            )}

            {responseData?.data?.length > 0 && (
                <React.Fragment>
                    <Row style={{overflowX: "auto"}}>
                        <Col md={12}>
                            <table className={"simpleClassicTable clientMovementsReportTable mb-2"} style={{width: "100%", tableLayout: "auto", wordBreak: "normal"}}>
                                <colgroup>
                                    <col span={1} style={{width: "2%"}}></col>
                                    <col span={1} style={{width: "20%"}}></col>
                                    <col span={1} style={{width: "10%"}}></col>
                                    <col span={1} style={{width: "15%"}}></col>
                                    <col span={1} style={{width: "10%"}}></col>
                                    <col span={1} style={{width: "15%"}}></col>
                                    <col span={1} style={{width: "15%"}}></col>
                                </colgroup>
                                <thead>
                                <tr>
                                    <th style={{border: "1px solid gray"}}>A/A</th>
                                    <th style={{border: "1px solid gray"}}>Αναγνωριστικό Λίστας</th>
                                    <th style={{border: "1px solid gray"}}>Ημερομηνία Δημιουργίας</th>
                                    <th style={{border: "1px solid gray"}}>Ημερομηνία Αποστολής</th>
                                    <th style={{border: "1px solid gray"}}>Πλήθος Voucher</th>
                                    <th style={{border: "1px solid gray"}}>Κατάσταση</th>
                                    <th style={{border: "1px solid gray"}}>Ημερομηνία Ολοκλήρωσης</th>
                                </tr>
                                </thead>
                                <tbody>
                                {responseData?.data?.map((row, idx) => (
                                    <tr key={`classTable-${idx}`} style={{cursor: "pointer", height: "45px", backgroundColor: statusOptions.find((el) => el.value === row["status"])?.color}} onClick={() => {
                                        dispatch(setSelectedPrimerPosList(row));
                                    }}>
                                        <td style={{border: "1px solid gray"}}>{row["no"]}</td>
                                        <td style={{border: "1px solid gray"}}>{row["acsListId"]}</td>
                                        <td style={{border: "1px solid gray"}}>{moment(row["created_at"]).format("DD/MM/YYYY HH:mm")}</td>
                                        <td style={{border: "1px solid gray"}}>{row["shippingDate"] ? moment(row["shippingDate"]).format("DD/MM/YYYY HH:mm") : ""}</td>
                                        <td style={{border: "1px solid gray"}}>{row["vouchers"]?.length || 0}</td>
                                        <td style={{border: "1px solid gray"}}>{statusOptions.find((el) => el.value === row["status"])?.label}</td>
                                        <td style={{border: "1px solid gray"}}>{row["completedDate"] ? moment(row["completedDate"]).format("DD/MM/YYYY HH:mm") : ""}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                </React.Fragment>
            )}
            <InsertPosListModal />
            <PrimerPosListModal />
            <AcsEmailModal show={showAcsEmailModal} setShow={setShowAcsEmailModal} />
        </React.Fragment>
    )
}

export default PrimerPosViewList;